module.exports = __webpack_public_path__ + "static/assets/451e76fa7a63e6734166bddb54b8e55f.svg";